import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-find-jobs',
  templateUrl: './find-jobs.component.html',
  styleUrls: ['./find-jobs.component.css']
})
export class FindJobsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
